// RMC companies do not have the ability to review a job or see inventory.

import { Company, UserRole } from 'src/types';

// They can only share a job with other full Yembo companies (partner companies in the partnerCompanyKeys array).
export const getIsNoReviewCompany = (
  authUserRole: UserRole,
  company?: Partial<Pick<Company, 'partnerCompanyKeys'>>
) => {
  if (authUserRole === 'superadmin') {
    return false;
  }

  return Boolean(company?.partnerCompanyKeys && company.partnerCompanyKeys.length > 0);
};
